"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PixelRecordView;
var _react = _interopRequireDefault(require("react"));
var _defaultPanelStyle = _interopRequireDefault(require("./defaultPanelStyle"));
var _PixelmonPropTypes = _interopRequireDefault(require("./PixelmonPropTypes"));
function PixelRecordView(_ref) {
  var pixelRecord = _ref.pixelRecord,
    onExitClick = _ref.onExitClick;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: _defaultPanelStyle["default"]
  }, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: onExitClick
  }, "Exit"), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h4", null, "Name:"), pixelRecord.pixelConfig.name), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h4", null, "Event:"), pixelRecord.pixelConfig.event), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h4", null, "renderedHtmlTemplate:"), pixelRecord.renderedHtmlTemplate), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h4", null, "context:"), JSON.stringify(pixelRecord.context || {}, null, 4)));
}